import moment from 'moment-timezone'
import { constants } from '@adc/ui-core'

const { states } = constants.optionLists

export const PARSERS = {
  DATE: 'DATE',
  TIME: 'TIME',
  EMAIL: 'EMAIL',
  BIDDER_NUMBER: 'BIDDER_NUMBER',
  EVENT_CODE: 'EVENT_CODE',
  STATE: 'STATE',
  WORD: 'WORD',
}

/**
 * Parsers for various format detection.
 * Each parser includes a regexp that should be global and return a full match each time it encounters desired format.
 * Optionally, can include a validator that will also be checked after value is found via regexp execution.
 */
export const parsers = {
  [PARSERS.DATE]: {
    regexp: new RegExp(/\b(\d{1,2})\/(\d{1,2})\/(\d{1,4})\b/g),
    validator: v => moment(v, 'M/D/YYYY').isValid(),
  },
  [PARSERS.TIME]: {
    regexp: new RegExp(
      /\b((0[0-9]|[0-9]|1[0-2]):[0-5][0-9] ?(AM|PM|am|pm))\b/g
    ),
    validator: v => moment(v, 'h:ma').isValid(),
  },
  [PARSERS.EMAIL]: {
    regexp: new RegExp(
      /\b(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))\b/g
    ),
  },
  [PARSERS.BIDDER_NUMBER]: {
    regexp: new RegExp(/\b[a-zA-Z]{3}-?\d{3}\b/g),
  },
  [PARSERS.EVENT_CODE]: {
    regexp: new RegExp(/\b([a-zA-Z]{1,}-[a-zA-Z0-9]{1,10})\b/g),
  },
  [PARSERS.STATE]: {
    regexp: new RegExp(
      `\\b(${states.map(state => state.text).join('|')})\\b`,
      'gi'
    ),
  },
  [PARSERS.WORD]: {
    regexp: new RegExp(/\b(?:\w|'|\/)+\b/g),
  },
}
